import { createSelector } from 'reselect'
import { colors } from '../styles'
import { someIsLoading } from '../services/common'
import { selectPack } from './pack'
import { selectGroup } from './group'
import { selectGroups } from './groups'
import { selectGroupsDetailed } from './groupsDetailed'
import { selectSearch } from './search'
import { selectPublishedSearch } from './publishedSearch'
import { selectMediaType, selectMediaTypes } from './mediaTypes'
import { selectMediaTypeGroup } from './mediaTypesGroups'
import { selectCapability, selectCapabilities } from './capabilities'
import { selectLanguages } from './languages'
import { selectPublishedGraphic } from './publishedGraphic'
import { selectServerConfig } from './config'
import { selectDataFile } from './datafile'
import { selectCapabilitiesSummary } from './capabilitiesSummary'
import { selectUserPreferences } from './userPreferences'
import { IOverlay } from '../components/Overlay/Overlay'

export const selectOverlay = createSelector(
  [
    selectPack,
    selectGroup,
    selectGroups,
    selectGroupsDetailed,
    selectSearch,
    selectPublishedSearch,
    selectMediaTypes,
    selectMediaType,
    selectMediaTypeGroup,
    selectCapabilities,
    selectCapability,
    selectLanguages,
    selectPublishedGraphic,
    selectServerConfig,
    selectDataFile,
    selectCapabilitiesSummary,
    selectUserPreferences,
  ] as any, // Use `any` due to known issue of reselect: https://github.com/reduxjs/reselect/issues/378
  (
    pack,
    group,
    groups,
    groupsDetailed,
    search,
    publishedSearch,
    mediaTypes,
    mediaType,
    mediaTypeGroup,
    capabilities,
    capability,
    languages,
    publishedGraphic,
    serverConfig,
    datafile,
    capabilitiesSummary,
    userPreferences
  ): IOverlay => ({
    isShown: someIsLoading([
      pack,
      group,
      groups,
      groupsDetailed,
      search,
      publishedSearch,
      mediaTypes,
      mediaType,
      mediaTypeGroup,
      capabilities,
      capability,
      languages,
      publishedGraphic,
      serverConfig,
      datafile,
      capabilitiesSummary,
      userPreferences,
    ]),
    spinnerColor: someIsLoading([pack, serverConfig, languages, datafile])
      ? colors.green
      : someIsLoading([search, capabilitiesSummary])
      ? colors.blue
      : colors.orange,
  })
)

export const selectOverlayIsShown = createSelector(
  selectOverlay,
  ({ isShown }) => isShown
)
